import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { FeatureModulesService } from '@spartacus/core';
import { map } from 'rxjs/operators';
import { COMMON_PRODUCT_COMPARATOR_FEATURE } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class ProductComparatorModuleGuard implements CanActivate {
  constructor(private featureModulesService: FeatureModulesService) {}

  canActivate(): Observable<boolean> {
    return this.featureModulesService.resolveFeature(COMMON_PRODUCT_COMPARATOR_FEATURE).pipe(map(() => true));
  }
}
